import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { MenuComponent } from './components/menu/menu.component';
import { TriggerForDirective } from './directives/trigger-for.directive';
import { MenuItemComponent } from './components/menu-item/menu-item.component';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule
  ],
  declarations: [
    MenuComponent,
    TriggerForDirective,
    MenuItemComponent
  ],
  exports: [
    MenuComponent,
    TriggerForDirective,
    MenuItemComponent
  ]
})
export class McRAIMenuModule { }
